// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BookingInformationView_Wrapper__3Fpga","Image":"BookingInformationView_Image__1V9YA","Text":"BookingInformationView_Text__S6XEu"};